import { LogLevel, PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store';
import App from './App';
import './App.css';
import './solissnetstyle.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-svg-core/styles.css';
import { getB2CConfiguration } from './configurations/environmentVariables';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const b2cConfig = getB2CConfiguration();

// Configuración MSAL
const msalConfig = {
    auth: {
        clientId: b2cConfig.clientId,
        authority: b2cConfig.authority,
        knownAuthorities: b2cConfig.knownAuthorities,
        redirectUri: b2cConfig.redirectUri,
        postLogoutRedirectUri: b2cConfig.redirectUri,
        navigateToLoginRequestUrl: b2cConfig.navigateToLoginRequestUrl
    },
    cache: {
        cacheLocation: b2cConfig.cacheLocation,
        storeAuthStateInCookie: b2cConfig.storeAuthStateInCookie
    },
    system: {
        loggerOptions: {
            loggerCallback: (level: number, message: string, containsPii: boolean) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    default:
                        return;
                }
            },
            logLevel: LogLevel.Verbose, // ← CAMBIAR A VERBOSE EN PRO temporalmente
            piiLoggingEnabled: false
        },
    },
};
const msalInstance = new PublicClientApplication(msalConfig);
const queryClient = new QueryClient();

root.render(
    <MsalProvider instance={msalInstance}>
        <QueryClientProvider client={queryClient}>
            <Provider store={store}>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </Provider>
        </QueryClientProvider>
    </MsalProvider>
);